// extracted by mini-css-extract-plugin
module.exports = {"switch-button-true":"toggle_switch-button-true__3ehoa","switch-button-false":"toggle_switch-button-false__3KBEt"};